/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

if(!window.GS) GS={};
if(!window.GS.Filters) GS.Filters={};
(function(){
    var f;
    f = new Class({
    //Extends: GS.BaseClass,
    Extends: GS.Filters.ColorEffects,
    class_name:'GS.Filters.ColoringEffect',
    options:{
        'dx': 0,
        'hue':0,
        'staturation': 1,
        'lightness' : 0, 
        'color_matrix':[],
        'brightness':0,
        'colorize':false,
        'sepia': false,
        'bw': false,
        'whitePointRGB' : {'r':255,'g':255,'b':255},
        'blackPointRGB' : {'r':0,'g':0,'b':0}
    },
    filter: {
        'id':0,
        'container':null,
        'saturation':null,
        'brightness':null,
        'color':null,
        'contrast':null,
        'compTransfert' : null,
        'hue' : null
    }
});

    /*
     * 
     * @returns {undefined}
     */
    f.prototype.createFilter=function(){
        var w = parseFloat(this.defs.ownerSVGElement.getAttribute('width')),
            h = parseFloat(this.defs.ownerSVGElement.getAttribute('height'));   
        var fID,
            f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB','filterUnits': "objectBoundingBox"});

        //console.warn('ADD THE NEW COLORING EFFECT FILTER AS `#%s`!', this.filter.id);
        this.filter.container=f;
        this.addColorFilter();
        this.defs.adopt(f);
    };
    
    /**
    * Create Color Filter element     
    * @returns {void}
    */
    f.prototype.addColorFilter=function(){
        var _tmp;
        //Add filter aperture/size
        this.filter.container.setAttribute('x','0%');
        this.filter.container.setAttribute('y','0%');
        this.filter.container.setAttribute('width','100%');
        this.filter.container.setAttribute('height','100%');

        // Add varnish....
        this.filter.varnish = this.addVarnish();

        // Add covering_white....
        //this.filter.coveringWhite = this.addCoveringWhite();

        // Add color...
        this.filter.color = this.addColor();

        // Add color variation ...
        this.filter.colorVariation =  this.addColorVariation();

        this.filter.sepia = this.addSepia();

        this.filter.bw = this.addBlackAndWhite();

        //Add foold rec
       // this.filter.flood = this.addFlood();

        //Add foold rec
       // this.filter.feImage = this.addFeImage();

        //Add white mapper
       // this.filter.whiteChannel = this.addWhiteMapper();

        //Add covering white
      //  this.filter.coveringWhite = this.addCoveringWhite();

        // Add saturation....
        this.filter.saturation = this.addMatrixFilter('saturation');

        // Add brightness....
        this.filter.brightness = this.addMatrixFilter('brightness');

        // Add hue rotation....
        this.filter.hue = this.addMatrixFilter('hue', 'hueRotate', "0");
        //this.filter.hue.setAttribute('in','white_mask_shape');



        //Add blend...
       // this.filter.blendWhite = this.addBlendWhite();
        this.filter.blend = this.addBlend();

        //Add merge...
        _tmp = this.addMerge();
        this.filter.merge = _tmp[0];
        this.filter.feMergeSurce = _tmp[1];
        //this.filter.feMergeWhite = _tmp[2];

        this.filter.container.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');

        this.filter.container.adopt([

           // this.filter.flood,
           // this.filter.feImage,
           // this.filter.whiteChannel,

            this.filter.color,
           // this.filter.coveringWhite,
            this.filter.varnish,
            this.filter.colorVariation,
            this.filter.saturation,
            this.filter.brightness,
            this.filter.hue,
            this.filter.sepia,
            this.filter.bw,
            //this.filter.coveringWhite,
            //this.filter.blendWhite,
            this.filter.blend,
            this.filter.merge]);

        this.update(this.options);
    };

    f.prototype.update=function(obj){
        //console.warn('UPDATING THE NEW COLORING EFFECT `#%s`!', this.filter.id);
        //console.log('Update Objec Filter', obj);
        this.remapColor(obj, 0, this.filter.color);
        this.remapColor(obj, 1, this.filter.color);
        this.setObjectColorVariation(obj.color, obj.colorize);
        this.setVarnish(obj.personalization || null);

       // this.setFlood(obj.personalization || null);
       // this.setFeImage(obj.personalization || null);

       // console.log('Reflect?', obj.reflect);

        this.setImageSaturation(obj.saturation);
        this.setImageBrightness(obj.brightness);
        this.setImageHue((!obj.personalization || obj.personalization.type !== 'raised_foil') ? obj.hue : 0);
        this.setBlend(obj.personalization || null);
        this.setSepia(obj.sepia);
        this.setBW(obj.bw);


       // this.setCoveringWhite(obj.personalization || null);

        if(obj.personalization && obj.personalization.color){
            this.filter.hue.setAttribute('result', 'void');
            this.filter.colorVariation.setAttribute('result', 'void');
        }else{
            this.filter.hue.setAttribute('result', 'transformed');
            this.filter.colorVariation.setAttribute('result', 'transformed');
        }
    }

    f.prototype.addColor = function(){
        var f = new Element('feComponentTransfer',  {in: 'SourceGraphic', result: 'transformed'});
        f.innerHTML = '' +
            '  <feFuncR type="table" tableValues="0 1"></feFuncR>\n' +
            '  <feFuncG type="table" tableValues="0 1"></feFuncG>\n' +
            '  <feFuncB type="table" tableValues="0 1"></feFuncB>';
        return f;
    };

    f.prototype.addSepia = function(){
        var f  = new Element('feColorMatrix', {'in': 'transformed', 'result': 'transformed', 'type': 'matrix', 'values': '', 'data-fx': 'sepia'});
        this.convertToSepia(this.options.colors.sepia);
        f.set('values', this.options.colors.sepia_matrix.join(' '));
        return f;
    }

    f.prototype.addBlackAndWhite = function(){

        var f = new Element('feColorMatrix', {'in': 'transformed', 'type': 'matrix', 'result': 'transformed', 'values': '', 'data-fx': 'b&w'});
        this.convertToBW(this.options.colors.bw);
        f.set('values', this.options.colors.bw_matrix.join(' '));
        return f;


    }

    f.prototype.addColorVariation = function(){
        return new Element('feColorMatrix',{'in':'transformed', 'data-fx':'color-variation','type':'matrix','result': 'transformed','color-interpolation-filters':'sRGB','values':'1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'});
    };
    
    f.prototype.addVarnish = function(){
        var f = new Element('feComponentTransfer',  {in: 'SourceAlpha', result: 'varnish'});
        f.innerHTML = '' +
            '  <feFuncR type="table" tableValues="0.9 0.9"></feFuncR>\n' +
            '  <feFuncG type="table" tableValues="0.9 0.9"></feFuncG>\n' +
            '  <feFuncB type="table" tableValues="0.9 0.9"></feFuncB>';
        return f;
    };

    f.prototype.addFlood = function(){
        return new Element('feFlood', {'flood-color': "#ffffff", 'flood-opacity': "1", result: "white_bg"});
    };

    f.prototype.addFeImage = function(){
        var SVG_NS = 'http://www.w3.org/2000/svg';
        var XLink_NS = 'http://www.w3.org/1999/xlink';
        var f = document.createElementNS(SVG_NS, 'feImage');
        f.setAttributeNS(null, 'result', 'white_mask_shape');
        f.setAttributeNS(null, 'preserveAspectRatio', 'none meet');
        f.setAttributeNS(null, 'externalResourcesRequired', 'true');
        return f;
    };

    f.prototype.addWhiteMapper = function(){
        var f = new Element('feComponentTransfer',  {in: 'white_mask_shape', result: 'white_mask'});
        f.innerHTML = '' +
            '  <feFuncR type="table" tableValues="1 1"></feFuncR>\n' +
            '  <feFuncG type="table" tableValues="1 1"></feFuncG>\n' +
            '  <feFuncB type="table" tableValues="1 1"></feFuncB>';
        return f;
    };

    f.prototype.addCoveringWhite = function() {
        var f, s, w, src;
        f = new Element('feMerge', {'result': 'white_level'});
        s = new Element('feMergeNode', {'in': 'white_bg', 'mode': 'normal'});
        src = new Element('feMergeNode', {'in': 'white_mask', 'mode': 'normal'});
        f.adopt([s, src]);
        return f;
    };


    f.prototype.addMerge = function(){
        var f, s, w, src;
        f = new Element('feMerge');
        src = new Element('feMergeNode',{'in':'transformed','mode':'normal'});
        f.adopt([src]);
        return [f,src];
    };

    f.prototype.addMatrixFilter = function(fx, type, values){
        if(!type) type = 'matrix';
        if(!values) values = '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0';
        return new Element('feColorMatrix',{'in':'transformed','data-fx': fx,'type': type,'result':'transformed','values': values});
    };

    f.prototype.addBlend = function(){
        return new Element('feBlend',  {in: 'transformed', in2: 'varnish', mode:"multiply", result: 'varnished'});
    };

    f.prototype.addBlendWhite = function(){
        return new Element('feBlend',  {in: 'white_level', in2: 'transformed', mode:"multiply", result: 'white_level'});
    };

    f.prototype.remapColor = function(obj,index, filter) {
        var tableValues, feFuncR, feFuncG, feFuncB, color;

        if(obj.personalization && obj.personalization.color){
            color = (!index) ? obj.personalization.color : null;
            filter.setAttribute('in', 'SourceAlpha');
        }else{
            filter.setAttribute('in', 'SourceGraphic');
            color = (!index) ? obj.blackPointRGB : obj.whitePointRGB;
            /*if(!obj.colorize){
                color = (!index) ? obj.blackPointRGB : obj.whitePointRGB;
            }else{
                color = (!index) ? obj.color : null;
            }*/

        }

        feFuncR = filter.querySelector('feFuncR');
        feFuncG = filter.querySelector('feFuncG');
        feFuncB = filter.querySelector('feFuncB');
        if(!color){
            switch(index){
                case 0:
                    color = {'r' : 0, 'g' : 0, 'b' : 0};
                break;
                case 1:
                     color = {'r' : 255, 'g': 255, 'b' : 255};
                break;
            }
        }
        
        //console.warn('Remap color %s using',index,color);
        //Remap red....
        if(feFuncR){
            tableValues = feFuncR.getAttribute('tableValues').split(' ');
            tableValues[index] = color.r / 255;
            feFuncR.setAttribute('tableValues', tableValues.join(' '));
        }
        //Remap green....
        if (feFuncG){
            tableValues = feFuncG.getAttribute('tableValues').split(' ');
            tableValues[index] = color.g / 255;
            feFuncG.setAttribute('tableValues', tableValues.join(' '));
        }
        if (feFuncB){
            tableValues = feFuncB.getAttribute('tableValues').split(' ');
            tableValues[index] = color.b / 255;
            feFuncB.setAttribute('tableValues', tableValues.join(' '));
        }
    };

    f.prototype.updateOld=function(obj){
        var use;
        use = obj.personalization && obj.personalization.color ? 'SourceAlpha' : 'SourceGraphic';
        this.filter.compTransfert.setAttribute('in', use);

       // console.debug('Update color filter',obj);
        if(obj.personalization && obj.personalization.color){
            this.remapColor(obj.personalization.color,0);
            this.remapColor(null, 1);
            this.filter.compTransfert.setAttribute('result','transformed');
            //this.filter.color.setAttribute('in', 'transformed2');
        }else{
            this.remapColor(obj.blackPointRGB,0);
            this.remapColor(obj.whitePointRGB,1);
            this.filter.color.setAttribute('in','transformed');
        }

        
        this.setImageBrightness(obj.brightness);
        this.setImageSaturation(obj.saturation);
        this.setObjectColorVariation(obj.color,obj.colorize);

        this.setImageHue(obj.hue);
        this.filter.saturation.set('values',this.options.saturation_matrix.join(' '));
        this.filter.brightness.set('values',this.options.brightness_matrix.join(' '));
        this.filter.color.set('values',this.options.color_matrix.join(' '));
        
        //Update shadow...
        if(obj.shadow){
            this.filter.shadowOffset.setAttribute('dx',obj.shadow.dx);
            this.filter.shadowOffset.setAttribute('dy',obj.shadow.dy);
            this.filter.shadowBlur.setAttribute('stdDeviation',obj.shadow.blur);
            var cMatrix;
            if(!obj.shadow.display || (obj.personalization && obj.personalization.color)){
                cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 0 0".substitute(obj.shadow.color);
            }else{
                cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(obj.shadow.color);
            }
            this.filter.shadowColor.setAttribute("values",cMatrix);
        }

        if(obj.personalization && obj.personalization.color)  {
            if(obj.color && obj.color.a!==1) {
                this.setObjectColor({
                    r: obj.color.r,
                    g: obj.color.g,
                    b: obj.color.b,
                    a: 1
                });
            }
            this.feMergeSurce.setAttribute('in','transformed2');
        }else{
            this.feMergeSurce.setAttribute('in','transformed');

        }
    };


    f.prototype.setVarnish = function(p){
        this.filter.feMergeSurce.setAttribute('in', (p && p.varnish) ? 'varnished' : 'transformed');
    };

    f.prototype.setSepia= function(sepia){
        this.convertToSepia(sepia);
        if(this.filter.sepia) this.filter.sepia.set('values', this.options.colors.sepia_matrix.join(' '));
    };

    f.prototype.setBW= function(bw){
        this.convertToBW(bw);
        if(this.filter.bw) this.filter.bw.set('values', this.options.colors.bw_matrix.join(' '));
    };

    f.prototype.setFlood = function(p){
        if(p && p.flood){
            this.filter.flood.setAttribute('x',p.flood.x);
            this.filter.flood.setAttribute('y',p.flood.y);
            this.filter.flood.setAttribute('width', p.flood.width);
            this.filter.flood.setAttribute('height', p.flood.height);
        }
    };

    f.prototype.setFeImage = function(p){
        if(p && p.feImage && p.feImage.src){
            if( p.feImage.reflect ){
                this.filter.feImage.setAttribute('transform',"scale("+p.feImage.reflect.join(',')+")");
            }
            this.filter.feImage.setAttribute('x', p.feImage.x);
            this.filter.feImage.setAttribute('y', p.feImage.y);
            this.filter.feImage.setAttribute('width', p.feImage.width);
            this.filter.feImage.setAttribute('height', p.feImage.height);
            this.filter.feImage.setAttributeNS('http://www.w3.org/1999/xlink', 'href', p.feImage.src);
            //this.filter.feImage.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', p.feImage.src);
            //this.filter.feImage.setAttribute('href', p.feImage.src);

        }
    };

    f.prototype.setCoveringWhite = function(p){
        if(p && p.covering_white){
            this.filter.blendWhite.setAttribute('result', 'transformed');
        }else{
            this.filter.blendWhite.setAttribute('result', 'void');
        }
    };

    f.prototype.setBlend = function(p){
        return;
        if(!p || !p.flood) {
            this.filter.blendWhite.setAttribute('result', 'transformed');
            this.filter.blendWhite.setAttribute('in', 'white_mask');
        }

        if(p && p.flood){
            this.filter.blendWhite.setAttribute('result', 'white_level');
            this.filter.blendWhite.setAttribute('in', 'white_level');
        }
        return;
        if(p && p.covering_white){
            this.filter.blend.setAttribute('in', 'white_level');
        }else{
            this.filter.blend.setAttribute('in', 'transformed');
        }
    };

    f.prototype.setObjectColorVariation=function(color,colorize){
        var cMatrix, r, g, b, a;

        cMatrix = [];
        r = (colorize) ? color.r / 255 : 1;
        g = (colorize) ? color.g / 255 : 1;
        b = (colorize) ? color.b / 255 : 1;
        a = (!isNaN(color.a)) ? color.a : 1;
        
        cMatrix = cMatrix.concat([r, 0, 0, 0, 0]);    // red
        cMatrix = cMatrix.concat([0, g, 0, 0, 0]);    // green
        cMatrix = cMatrix.concat([0, 0, b, 0, 0]);    // blue
        cMatrix = cMatrix.concat([0, 0, 0, a, 0]);          // alpha

        this.options.color_matrix = cMatrix;
        if (this.filter.colorVariation) this.filter.colorVariation.setAttribute('values', cMatrix);
    };

    f.prototype.setImageSaturation=function(v){
        var cMatrix = [],lumaR,lumaG,lumaB,i,r,g,b;
        lumaR = 0.212671;
        lumaG = 0.71516;
        lumaB = 0.072169;
        v=v/100+1;

        i = (1 - v);
        r = (i * lumaR);
        g = (i * lumaG);
        b = (i * lumaB);

        cMatrix = cMatrix.concat([(r + v), g, b, 0, 0]);    // red
        cMatrix = cMatrix.concat([r, (g + v), b, 0, 0]);    // green
        cMatrix = cMatrix.concat([r, g, (b + v), 0, 0]);    // blue
        cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);          // alpha

        this.options.saturation_matrix = cMatrix;
        if (this.filter.saturation) this.filter.saturation.setAttribute('values', this.options.saturation_matrix.join(' '));
    };

    f.prototype.setImageBrightness=function(s){
        var cMatrix=[];
        s=-Number(s)/100;

        cMatrix=cMatrix.concat([1,0,0,0,s]);// red
        cMatrix=cMatrix.concat([0,1,0,0,s]);// green
        cMatrix=cMatrix.concat([0,0,1,0,s]);// blue
        cMatrix=cMatrix.concat([0,0,0,1,0]);// alpha

        this.options.brightness_matrix = cMatrix;
        if (this.filter.brightness) this.filter.brightness.setAttribute('values', this.options.brightness_matrix.join(' '));
    };

    f.prototype.setImageHue=function(hue){
        if(this.filter.hue) this.filter.hue.setAttribute('values',hue);
    };

    /**
     *
     * @param {boolean} v
     * @returns {void}
     */
    f.prototype.convertToSepia=function(v){
        var cMatrix = [],
            amount = 0.5,
            r=(v) ? (0.393 + 0.607 * (1 - amount)) : 1,
            g=(v) ? (0.686 + 0.314 * (1 - amount)) : 1,
            b=(v) ? (0.131 + 0.869 * (1 - amount)) : 1,

            rx=(v) ? (0.769 - 0.769 * (1 - amount)) : 0,
            ry=(v) ? (0.189 - 0.189 * (1 - amount)) : 0,

            gx=(v) ? (0.349 - 0.349 * (1 - amount)) : 0,
            gy=(v) ? (0.168 - 0.168 * (1 - amount)) : 0,

            bx=(v) ? (0.272 - 0.272 * (1 - amount)) : 0,
            by=(v) ? (0.534 - 0.534 * (1 - amount)) : 0;




        cMatrix = cMatrix.concat([r , rx, ry, 0, 0]);    // red
        cMatrix = cMatrix.concat([gx, g, gy, 0, 0]);    // green
        cMatrix = cMatrix.concat([bx, by, b, 0, 0]);    // blue
        cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);          // alpha
        this.options.colors.sepia_matrix=cMatrix;
    };

    /**
     *
     * @param {boolean} v
     * @returns {void}
     */
    f.prototype.convertToBW=function(v){
        //b&w matrix [0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0]
        //normal matrix [1 0 0 0 0 0 0 1 0 0 0 0 0 0 1 0 0 0 0 0 1 0]
        var cMatrix = [],
            r=(v) ? 0.33 : 1,
            g=(v) ? 0.33 : 1,
            b=(v) ? 0.33 : 1,

            rx=(v) ? 0.33 : 0,
            ry=(v) ? 0.33 : 0,

            gx=(v) ? 0.33 : 0,
            gy=(v) ? 0.33 : 0,

            bx=(v) ? 0.33 : 0,
            by=(v) ? 0.33 : 0;

        cMatrix = cMatrix.concat([r , rx, ry, 0, 0]);    // red
        cMatrix = cMatrix.concat([gx, g, gy, 0, 0]);    // green
        cMatrix = cMatrix.concat([bx, by, b, 0, 0]);    // blue
        cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);          // alpha


        this.options.colors.bw_matrix=cMatrix;
    };
    
    this.ColoringEffects=f;
}.call(this.GS.Filters));
